export default __webpack_public_path__ + "static/media/arrow_down.ee142954.svg";